import React, {Fragment, useState} from "react";
import useSerializedRefresh from "../useSerializedRefresh";
import ApiService from "../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import DonationButton from "./donation-button";
import {getCurrencyFormater, getDeviseSymbol} from "../../../i18n";
import {Trans} from "@lingui/react/macro";
import {getPrimaryColor} from "../tokens";
import logger from "../../../services/logger"


export default function TeamProgress({context,campagneData,campagneTarget}){

    const [teamStats,setTeamStats]=useState(null)

    const isMobile=context.isMobile

    const getTeamStats=async ()=>{
        const _id=campagneData?.id
        const _team=campagneTarget.initial.team

        logger.debug({ _team }, "team-progress team")

        if(!_id || !_team){
            return false
        }

        const res=await ApiService.get("/campagne/team/stats/"+_id+"/"+_team)

        setTeamStats(res.data)
    }


    useSerializedRefresh(getTeamStats, campagneData?._liveRevision)


    if(!teamStats || !campagneTarget.initial.team){
        return null
    }

    const teamData=campagneData.teams.find(i=>i.param===campagneTarget.initial.team)
    if(!teamData){ return null }

    //console.log("teamStats",teamStats)
    //console.log("teamData",teamData)

    const teamTotal=teamStats.sum.total
    const teamCount=teamStats.count.total

    const objective=Number(teamData.objectif)
    const percent=Number.isFinite(objective) && objective>0 ? (teamTotal/objective)*100 : 0

    let progressColor=getPrimaryColor(campagneData.config)

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })

    const currencyFormater=getCurrencyFormater(context)

    return(
        <div className={"container"} style={{padding:isMobile?"4rem 1rem":"4rem 0",display:"flex",flexDirection:"column",justifyContent:"center"}}>

            <span style={{fontSize:isMobile?"2rem":"3rem",fontWeight:900,textAlign:"center",width:"100%",marginBottom:"0.5rem"}}>{teamData.label}</span>

            <ProgressBar
                customLabel={" "}
                animateOnRender
                completed={percent}
                width={"100%"}
                height={"1rem"}
                bgColor={progressColor}
            />
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:"0.5rem"}}>
                {/* Une équipe créée par inscription libre n'a pas toujours d'objectif :
                    « sur NaN € » s'affichait alors publiquement. */}
                <span style={{fontSize:"1rem"}}>
                    <span style={{fontWeight:700}}>{currencyFormater(teamTotal)}</span>
                    {objective>0 ? <Fragment> <Trans>sur</Trans> {currencyFormater(objective)}</Fragment> : null}
                </span>
                <span style={{fontSize:"1rem"}}><span style={{fontWeight:700}}>{teamCount}</span> <Trans>Donateur(s)</Trans></span>
            </div>


            <div style={{display:"flex",alignItems:"center",justifyContent:"center",marginTop:"1rem"}}>
                <DonationButton context={context} />
            </div>

        </div>
    )
}
